import api from './api';

export const loginUser = async (email, password) => {
  try {
    // API expects username and password in form format
    const params = new URLSearchParams();
    params.append('username', email);
    params.append('password', password);

    const response = await api.post('/auth/login', params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    const { access_token } = response.data;
    
    // Store token
    localStorage.setItem('token', access_token);
    
    // Get user info with the token
    const user = await getCurrentUser();
    
    return user;
  } catch (error) {
    console.error('Login error:', error.response?.data || error.message);
    throw new Error(error.response?.data?.detail || 'Failed to login');
  }
};

export const getCurrentUser = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No token found');
    }
    
    // Get current user profile
    const response = await api.get('/users/me');
    const user = response.data;
    
    // Store user data
    localStorage.setItem('user', JSON.stringify(user));
    
    return user;
  } catch (error) {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    throw error;
  }
};

export const logoutUser = async () => {
  // Clear local storage
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  // No need for an API call since we're using JWT
  return true;
};

export const getStoredUser = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (error) {
    console.error('Error parsing stored user:', error);
    return null;
  }
};